import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface PaginationProps {
  value: number
  count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LPagination',
  props: {
    value: null,
    count: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: number
  count: number
};




const page = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('input', value)
  },
})

const numberOfPages = computed(() => Math.ceil(props.count / 10))
const itemsStart = computed(() => (props.count ? page.value * 10 - 9 : 0))
const itemsEnd = computed(() => Math.min(page.value * 10, props.count))

return { __sfc: true,props, emit, page, numberOfPages, itemsStart, itemsEnd }
}

})